"use client";

import { appConfig } from "@/constants";
import {
  getQuestFromFieldData,
  getQuestSections,
} from "@/domain/gems-game/data-access/lib/cms";
import { getQuests } from "@imx-tokens-ts/gems-game/data-access";
import { useMemo } from "react";
import useSWRImmutable from "swr/immutable";

export const QUESTS_DATA_KEY = "/quests";
export const QUESTS_SECTIONS_DATA_KEY = "/quest_sections";

export const useQuests = () => {
  const {
    data: rawData,
    error,
    isLoading,
  } = useSWRImmutable(QUESTS_DATA_KEY, async () => {
    return await getQuests(fetch, appConfig.QUESTS_CMS_URL);
  });

  const processedData = useMemo(() => {
    if (!rawData) return undefined;

    return {
      featuredQuests: rawData.featuredQuests.map(getQuestFromFieldData),
      mainQuests: rawData.mainQuests.map(getQuestFromFieldData),
      sideQuests: rawData.sideQuests.map(getQuestFromFieldData),
      onboardingQuests: rawData.onboardingQuests.map(getQuestFromFieldData),
      seriesQuests: rawData.seriesQuests.map(getQuestFromFieldData),
      inGameQuests: rawData.inGameQuests.map(getQuestFromFieldData),
    };
  }, [rawData]);

  return {
    data: processedData,
    error,
    isLoading,
  };
};

export const useQuestSections = () =>
  useSWRImmutable(QUESTS_SECTIONS_DATA_KEY, () =>
    getQuestSections(fetch, appConfig.QUEST_SECTIONS_CMS_URL),
  );
